module.exports = __webpack_public_path__ + "img/obs_quality_normal.8cffcf8c.svg";